import React, { useState, useEffect } from 'react';
import './BluetoothPrinter.css';

const BluetoothPrinter = ({ cart, total }) => {
  const [printer, setPrinter] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [connecting, setConnecting] = useState(false);

  const connectPrinter = async () => {
    try {
      setConnecting(true);
      // Web Bluetooth API for now, will be replaced with Capacitor
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb']
      });

      const server = await device.gatt.connect();
      const service = await server.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb');
      const characteristic = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb');

      setPrinter({ device, characteristic });
      setIsConnected(true);

      device.addEventListener('gattserverdisconnected', () => {
        setIsConnected(false);
        setPrinter(null);
      });

    } catch (error) {
      console.error('Error connecting to printer:', error);
      alert('Failed to connect to printer. Make sure Bluetooth is enabled.');
    } finally {
      setConnecting(false);
    }
  };

  const disconnectPrinter = () => {
    if (printer?.device?.gatt?.connected) {
      printer.device.gatt.disconnect();
    }
    setPrinter(null);
    setIsConnected(false);
  };

  const printReceipt = async () => {
    if (!printer || !isConnected) {
      alert('Please connect to a printer first');
      return;
    }

    if (cart.length === 0) {
      alert('Cart is empty');
      return;
    }

    try {
      // ESC/POS commands for thermal printers
      const ESC = '\x1B';
      const GS = '\x1D';
      
      let receipt = ESC + '@'; // Initialize
      receipt += ESC + 'a' + '\x01'; // Center align
      receipt += ESC + '!' + '\x30'; // Double size
      receipt += 'MyPOS System\n';
      receipt += ESC + '!' + '\x00'; // Normal size
      receipt += 'Order Receipt\n';
      receipt += ESC + 'a' + '\x00'; // Left align
      receipt += '--------------------------------\n';
      
      // Items
      cart.forEach(item => {
        const name = item.name || item.NAME || 'Item';
        const price = parseFloat(item.price || item.BASE_PRICE || 0);
        const qty = item.quantity || 1;
        const total = price * qty;
        
        receipt += name + '\n';
        receipt += `${qty} x $${price.toFixed(2)} = $${total.toFixed(2)}\n`;
        receipt += '\n';
      });
      
      // Total
      receipt += '--------------------------------\n';
      receipt += ESC + '!' + '\x10'; // Double height
      receipt += `TOTAL: $${total.toFixed(2)}\n`;
      receipt += ESC + '!' + '\x00'; // Normal size
      receipt += '--------------------------------\n';
      
      // Footer
      receipt += ESC + 'a' + '\x01'; // Center align
      receipt += 'Thank you for your business!\n';
      receipt += new Date().toLocaleString() + '\n';
      receipt += '\n\n\n';
      
      // Cut paper
      receipt += GS + 'V' + 'B' + '\x00';
      
      // Convert to ArrayBuffer
      const encoder = new TextEncoder();
      const data = encoder.encode(receipt);
      
      await printer.characteristic.writeValue(data);
      console.log('Receipt printed successfully');
      
    } catch (error) {
      console.error('Error printing receipt:', error);
      alert('Failed to print receipt. Please check printer connection.');
    }
  };

  return (
    <div className="bluetooth-printer">
      <div className="printer-header">
        <h3>🖨️ Bluetooth Printer</h3>
        <div className="connection-status">
          <span className={status }>
            {isConnected ? '● Connected' : '○ Disconnected'}
          </span>
        </div>
      </div>

      <div className="printer-controls">
        {!isConnected ? (
          <button 
            onClick={connectPrinter}
            disabled={connecting}
            className="connect-btn"
          >
            {connecting ? 'Connecting...' : '🔗 Connect Printer'}
          </button>
        ) : (
          <button 
            onClick={disconnectPrinter}
            className="disconnect-btn"
          >
            🔌 Disconnect
          </button>
        )}
      </div>

      {isConnected && (
        <div className="print-actions">
          <button 
            onClick={printReceipt}
            disabled={cart.length === 0}
            className="print-btn"
          >
            {cart.length === 0 ? 'Cart Empty' : '🧾 Print Receipt'}
          </button>
        </div>
      )}

    </div>
  );
};

export default BluetoothPrinter;
